import FJConstant from '../../constants/FJConstant.js';
import FJTTVIcon from '../../assets/svg/ttv/text-to-speech.svg?react';
import FJCloneVoiceIcon from '../../assets/svg/ttv/clone-voice.svg?react';
import FJLibraryIcon from '../../assets/svg/ttv/library.svg?react';
import FJFavoriteIcon from '../../assets/svg/ttv/favorite.svg?react';
import FJMyCreationIcon from '../../assets/svg/ttv/my-creations.svg?react';

const FJTextToSpeechData = {
    MENU_LIST: [
        {
            name: 'text-to-speech',
            value: FJConstant.TEXT_TO_SPEECH,
            icon: FJTTVIcon,
        },
        {
            name: 'voice-cloning',
            value: FJConstant.CLONE_VOICE,
            icon: FJCloneVoiceIcon,
        },
        {
            value: FJConstant.LINE,
        },
        {
            name: 'library',
            value: FJConstant.VOICE_LIST,
            icon: FJLibraryIcon,
        },
        {
            name: 'favorites',
            value: FJConstant.FAVORITE,
            icon: FJFavoriteIcon,
        },
        {
            name: 'history-1',
            value: FJConstant.HISTORY,
            icon: FJMyCreationIcon,
        },
    ],
    LANGUAGE_LIST: [
        { value: 'en', label: 'English' },
        { value: 'cn', label: '中文' },
        { value: 'de', label: 'Deutsch' },
        { value: 'jp', label: '日本語' },
        { value: 'fr', label: 'Français' },
        { value: 'es', label: 'Español' },
        { value: 'kr', label: '한국인' },
        { value: 'ar', label: 'ربي' },
    ],
    DEFAULT_SPEECH_INFO: {
        voiceInfo: {},
        generationType: FJConstant.MICROSOFT,
        status: FJConstant.DEFAULT,
        audioUrl: '',
        audioDuration: 0,
        text: '',
    },
    DEFAULT_VOICE: {
        en: {
            value: 'en-US-JennyNeural',
            label: 'Jenny',
        },
        cn: {
            value: 'zh-CN-XiaoyiNeural',
            label: 'Xiaoyi - 晓伊',
        },
        de: {
            value: 'de-DE-KatjaNeural',
            label: 'Katja',
        },
        jp: {
            value: 'ja-JP-KeitaNeural',
            label: 'Keita - 圭太',
        },
        fr: {
            value: 'fr-FR-DeniseNeural',
            label: 'Denise',
        },
        es: {
            value: 'es-ES-ElviraNeural',
            label: 'Elvira',
        },
        ar: {
            value: 'ar-SA-ZariyahNeural',
            label: 'Zariyah - زارية',
        },
        pt: {
            value: 'pt-PT-RaquelNeural',
            label: 'Raquel',
        },
        tw: {
            value: 'zh-TW-YunJheNeural',
            label: 'YunJhe - 雲哲',
        },
    },
};

export default FJTextToSpeechData;
